import { render, staticRenderFns } from "./InitiateFirm.vue?vue&type=template&id=2deb7005&scoped=true"
import script from "./InitiateFirm.vue?vue&type=script&lang=js"
export * from "./InitiateFirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb7005",
  null
  
)

export default component.exports